module.exports = self._;


//////////////////
// WEBPACK FOOTER
// external "self._"
// module id = 0
// module chunks = 0